/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFeesV1FeeRateState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FEES_V1_FEE_RATE_STATE_ENTITY_NAME = 'ixc.fees.v1.FeeRate';
export const ixcFeesV1FeeRateStateEntity = new schema.Entity<IxcFeesV1FeeRateState>(IXC_FEES_V1_FEE_RATE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcFeesV1FeeRateState) => `${entity.feeType}-${entity.effectiveDate}` });

